import * as Yup from 'yup';
import { Dto } from "../../../parts/crud/dto";
import { v4 as uuidv4 } from 'uuid';


export class exctractorDto extends Dto {

  constructor() {
    super();
    this.data.initialValues = {

      codename: uuidv4().toUpperCase(),
      name_extractor: '',
      ftp_host: '',
      ftp_port: '',
      ftp_username: '',
      ftp_passwd: '',
      params: '',
      autobalance: 0,
      servers: [],
      brokers: [],
    }

    console.log(this.data.initialValues)

    this.data.validationSchema = Yup.object({
      codename: Yup.string().required('Il campo GUID è obbligatorio'),
      name_extractor: Yup.string().required('Il campo nome è obbligatorio'),
      ftp_host: Yup.string().required('Il campo Host FTP è obbligatorio'),
      ftp_port: Yup.string().required('Il campo Porta FTP è obbligatorio'),
      ftp_username: Yup.string().required('Il campo Username FTP è obbligatorio'),
      ftp_passwd: Yup.string().required('Il campo Password FTP è obbligatorio'),
      servers: Yup.array().test('len', 'Seleziona almeno un server', (val:any) => (val.length > 0)),
      brokers: Yup.array().test('len', 'Seleziona almeno un broker', (val:any) => (val.length > 0)),

    });
  }


}